const Main = (props) => {
  return (
    <main className="min-h-full flex flex-grow flex-col items-center font-magBook">
      {props?.children}
    </main>
  );
};

export default Main;
